import React from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import { highlights } from '../data';
import '../styles/theme.css';

export default function About() {
  const fade = useFadeIn();

  return (
    <section id="about" className="section">
      <SectionLabel>About</SectionLabel>
      <div ref={fade.ref} style={fade.style} className="grid-2">
        <div>
          {[
            "Software Engineer with 4+ years of experience building enterprise-grade software.",
            "Experienced in building scalable backend systems using Java and Spring Boot.",
            "Full-stack developer with hands-on experience in React and modern web technologies.",
            "Cloud experience across AWS and GCP, with exposure to on-premises enterprise infrastructure.",
            "Focused on designing reliable, secure, and high-performance systems.",
            "Passionate about continuous learning and staying ahead of emerging technologies."
          ].map((p, i) => (
            <p key={i} className="about__p">{p}</p>
          ))}

        </div>

        <div className="stats-grid">
          {highlights.map(({ highlight, label }) => (
            <div key={label} className="stat-card">
              <div className="stat-number">{highlight}</div>
              <div className="stat-label">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
